import * as yup from "yup";

export const schemaErrorsPost = yup.object().shape({
  caption: yup.string().required("Legenda não pode ficar em branco."),
});
